import { Plus } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useTranslation } from "@/i18n";

interface StepProps {
  index: number;
  active?: boolean;
  title: string;
  children: React.ReactNode;
}

function Step({ index, active, title, children }: StepProps) {
  return (
    <div className="rounded-md border border-ocean-100 bg-white p-4">
      <div className="flex items-start gap-3">
        <div
          className={
            "flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-medium " +
            (active
              ? "bg-ocean-600 text-white"
              : "bg-ocean-100 text-ocean-600")
          }
        >
          {index}
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-medium text-ocean-900">{title}</div>
          <div className="mt-2 text-xs text-neutral-600">{children}</div>
        </div>
      </div>
    </div>
  );
}

interface Props {
  onCreateClick: () => void;
}

export function AssetsQuickstart({ onCreateClick }: Props) {
  const { t } = useTranslation();
  return (
    <div className="rounded-lg border border-ocean-100 bg-ocean-50/40 p-5 desktop:p-7">
      <h2 className="text-lg font-medium text-ocean-900">
        {t("assets.quickstart.title")}
      </h2>
      <p className="mt-1 max-w-2xl text-sm text-neutral-600">
        {t("assets.quickstart.description")}
      </p>

      <div className="mt-5 space-y-3">
        <Step index={1} active title={t("assets.quickstart.step1Title")}>
          {t("assets.quickstart.step1Body")}
          <div className="mt-3">
            <Button size="sm" onClick={onCreateClick}>
              <Plus size={14} />
              {t("assets.actions.create")}
            </Button>
          </div>
        </Step>

        <Step index={2} title={t("assets.quickstart.step2Title")}>
          {t("assets.quickstart.step2Body")}
        </Step>

        <Step index={3} title={t("assets.quickstart.step3Title")}>
          {t("assets.quickstart.step3Body")}
        </Step>
      </div>
    </div>
  );
}
